import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "rootElement",
  class: "d-flex flex-column justify-content-between h-100"
}
const _hoisted_2 = {
  key: 0,
  class: "row row-name mb-2"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row row-settings mb-2" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  key: 1,
  class: "col-12 mb-2"
}
const _hoisted_7 = {
  key: 2,
  class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2"
}
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "page-selector d-flex align-items-center me-3 mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "article", -1)
const _hoisted_11 = { class: "linked-page-name d-flex align-items-center" }
const _hoisted_12 = { class: "d-flex justify-content-center align-items-center border border-1 rounded fst-italic px-3 py-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "close", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2"
}
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  key: 4,
  class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2"
}
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "d-flex flex-column" }
const _hoisted_20 = { class: "row align-items-center pt-3 border-top border-1 border-black border-opacity-25" }
const _hoisted_21 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_22 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_23 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_24 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_CpAbstractsOverview = _resolveComponent("CpAbstractsOverview")!
  const _component_base_modal = _resolveComponent("base-modal")!
  const _component_AutoSaveFeedback = _resolveComponent("AutoSaveFeedback")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (!_ctx.pageUI.getIsReady())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.pageUI.getIsReady())
        ? (_openBlock(), _createBlock(_component_dp_form, {
            key: 0,
            as: "form",
            onSubmit: _ctx.submitData,
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              (_ctx.mode === _ctx.PageDetailModeEnum.NEW)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_input_select, {
                            modelValue: _ctx.association.association_type_code,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.association.association_type_code) = $event)),
                            name: _ctx.$t('type'),
                            label: _ctx.$t('type'),
                            options: _ctx.associationTypeOptions,
                            rules: "required",
                            errors: errors
                          }, null, 8, ["modelValue", "name", "label", "options", "errors"])
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.associationTypeDescription), 1)
                  ])),
              (_ctx.association.association_type_code === _ctx.PopupAssociationTypeEnum.PAGE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_base_modal_button, {
                          class: "btn btn-icon btn-sm btn-warning",
                          "modal-id": "association_content_page"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createTextVNode(_toDisplayString(_ctx.$t('select') + ' ' + _ctx.$t('page').toLowerCase()), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_base_modal, {
                          "modal-id": "association_content_page",
                          "dialog-classes": "modal-xl modal-dialog-scrollable",
                          title: _ctx.$t('contentPages')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CpAbstractsOverview, {
                              "enable-alt-lang-pages": _ctx.enableAltLangPages,
                              onExceptions: _ctx.setExceptions,
                              onSelectedCp: _ctx.setPageId
                            }, null, 8, ["enable-alt-lang-pages", "onExceptions", "onSelectedCp"])
                          ]),
                          _: 1
                        }, 8, ["title"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.linkedPage?.name ?? _ctx.$t('noPageSelected')), 1),
                        (_ctx.linkedPage)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearPageId && _ctx.clearPageId(...args)), ["prevent"])),
                              class: "btn btn-icon btn-sm ms-1"
                            }, _hoisted_14))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.association.association_type_code === _ctx.PopupAssociationTypeEnum.COLLECTION_TYPE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_input_select, {
                        modelValue: _ctx.association.page_collection_code,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.association.page_collection_code) = $event)),
                        name: _ctx.$t('collection'),
                        label: _ctx.$t('collection'),
                        options: _ctx.pageTypeOptions,
                        rules: "required",
                        errors: errors,
                        onChange: _ctx.onAssociationChanged
                      }, null, 8, ["modelValue", "name", "label", "options", "errors", "onChange"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.association.association_type_code === _ctx.PopupAssociationTypeEnum.SNIPPET)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_input_select, {
                        modelValue: _ctx.association.snippet_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.association.snippet_id) = $event)),
                        name: _ctx.$t('snippet'),
                        label: _ctx.$t('snippet'),
                        options: _ctx.snippetOptions,
                        rules: "required",
                        errors: errors,
                        onChange: _ctx.onAssociationChanged
                      }, null, 8, ["modelValue", "name", "label", "options", "errors", "onChange"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.mode === _ctx.PageDetailModeEnum.EDIT || _ctx.association.association_type_code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.$t('save')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.autoSaveFeedbackStatus !== _ctx.AutoSaveFeedbackStatusEnum.NONE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_AutoSaveFeedback, { status: _ctx.autoSaveFeedbackStatus }, null, 8, ["status"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_base_offcanvas_button_close, {
                      ref: "closeButton",
                      class: "btn btn-light"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
                      ]),
                      _: 1
                    }, 512)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true)
    ], 512)
  ], 64))
}